"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _buttonDropdownModule = _interopRequireDefault(require("./button-dropdown.module.scss"));
var _button = _interopRequireWildcard(require("./button"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
class ButtonDropdown extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      menuOpen: false
    });
    (0, _defineProperty2.default)(this, "handleOutsideClick", e => {
      if (this.dropdownMenu && !this.dropdownMenu.contains(e.target)) {
        this.setState({
          menuOpen: false
        });
      }
    });
    (0, _defineProperty2.default)(this, "handleDropdownButtonItemClick", () => {
      this.setState({
        menuOpen: false
      });
    });
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
  isDisabled() {
    return this.props.loading || this.props.disabled;
  }
  handleDropdownButtonClick() {
    if (!this.isDisabled()) {
      this.setState(prevState => ({
        menuOpen: !prevState.menuOpen
      }), () => this.state.menuOpen && document.addEventListener('click', this.handleOutsideClick));
    }
  }
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      buttonProps = _objectWithoutProperties(_this$props, _excluded);
    const dropdownItems = _react.default.Children.toArray(children).filter(child => child.type && child.type.displayName === 'ButtonDropdownItem');
    const buttonText = _react.default.Children.toArray(children).filter(child => !child.type);
    const attributes = {};
    if (this.isDisabled()) {
      attributes.disabled = 'disabled';
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _buttonDropdownModule.default.buttonDropdownWrap,
      ref: element => {
        this.dropdownMenu = element;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      onClick: e => this.handleDropdownButtonClick(e)
    }, /*#__PURE__*/_react.default.createElement(_button.default, buttonProps, buttonText, /*#__PURE__*/_react.default.createElement(_icon.default, {
      size: "small",
      className: _buttonDropdownModule.default.icon,
      type: "arrow-down"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_buttonDropdownModule.default.buttonDropdownMenu, {
        [_buttonDropdownModule.default.menuOpen]: this.state.menuOpen
      }),
      onClick: this.handleDropdownButtonItemClick
    }, dropdownItems));
  }
}
exports.default = ButtonDropdown;
ButtonDropdown.propTypes = _objectSpread(_objectSpread({}, _button.ButtonProps), {}, {
  children: _propTypes.default.node
});